import React from "react";
import { Link } from "react-router-dom";
import "./ThankYouContactUs.css";

const ThankYouContactUs = () => {
    return (
        <div>
            <div className="thank-you-container">
                <img
                    src="/assets/images/task.png"
                    alt="Thank you icon"
                    className="thank-you-icon"
                />
                <h1>
                    Thank you for reaching out to <span className="highlight">Ambrum</span>!
                </h1>
                <p className="subtext">
                    We’ve received your message and our team will be in touch shortly.
                </p>
                <p className="subtext">
                    In the meantime, feel free to explore our work and insights on the{" "}
                    <Link to="/blog">Blog</Link> or <Link to="/portfolio">Portfolio</Link>.
                </p>
                <Link to="/" className="home-button">
                    <span>❮</span> Home
                </Link>
            </div>
        </div>
    );
};

export default ThankYouContactUs;
